// @flow
import React from 'react';
import type { Element } from 'react';

import type { Event } from '@globalTypes';

import { StyledLabel, StyledInput } from './styles';
import type { Props } from './types';

const HoneypotField = ({ value, onChange }: Props): Element<any> => (
  <>
    <StyledLabel htmlFor="password_reconfirmation">Password Reconfirmation</StyledLabel>
    <StyledInput
      name="password_reconfirmation"
      id="password_reconfirmation"
      autoComplete="off"
      type="text"
      placeholder="Password Reconfirmation"
      value={value}
      onChange={(event: Event) => onChange(event.target.value)}
    />
  </>
);

export default HoneypotField;
